<template>
  <section
    v-if="!headerOpen && (scrollPosition > 64 || isMobile) "
    class=" nav-hero teq-container "
    :class="{'stepping-active' : isSteppingVisible(), 'banner-active': isBannerOpen()}"
  >
    <nav-burger />
    <div
      :class="scrollPosition > 64 && !isSteppingVisible() ? 'mobility-logo-container -hidden-mobile-scroll' : 'mobility-logo-container' "
    >
      <div class="menu-desktop">

       

        <a
          v-if="scrollPosition > 65"
          class="logo-link -svg"
          href="/"
        > <img
        src="../../../../images/logo-new.svg"
  >
        </a>
      </div>

      <div
        class="menu-mobile"
        v-if="scrollPosition < 64 || isMobile"
      >
        <a
          class="logo-link"
          href="/"
        > <img
        src="../../../../images/logo-new.svg"
  >
        </a>
      </div>
    </div>
    <div
      class="header-booking-button"
      v-show=" !isMobile && !isSteppingVisible()"
    >
      <rent-button
        @buttonclicked="showHeader()"
        class="button-header"
        grey
      >
        <svg class="icon-calendar">
          <use xlink:href="#icon-calendar"></use>
        </svg>
        <span>Réservez votre véhicule</span>
      </rent-button>
    </div>
    <div
      class="header-booking-button"
      v-show="scrollPosition > 64 && isMobile && !isSteppingVisible()"
    >
      <rent-button
        @buttonclicked="showHeader()"
        class="button-header"
        grey
      >
        <svg class="icon-calendar">
          <use xlink:href="#icon-calendar"></use>
        </svg>
        <span>Réservez votre véhicule</span>
      </rent-button>
      <img
        class="illust"
        src="../../../../images/logo-new.svg"
        alt=""
      >
    </div>
    <div
      v-if="!isMobile"
      class="logo-container"
    />
  </section>
</template>
<script>

import { mapState } from 'vuex'
import NavBurger from './NavBurger'
import RentButton from '../RentButton'

export default {
  name: 'NavCenter',
  components: {
    NavBurger,

    RentButton,
  },
  data() {
    return {
      scrollPosition: null,
    }
  },

  computed: {
    ...mapState({
      stepping: (state) => state.stepping,
    }),
    headerOpen() {
      return this.$store.state.stepping.header
    },
    isMobile() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) return true
      return false
    },
  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  methods: {
    isSteppingVisible() {
      return !!this.stepping.currentStep
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
      if (this.scrollPosition === 0) this.$store.commit('stepping/SET_HEADER', false)
    },
    showHeader() {
      this.$store.commit('stepping/SET_HEADER', true)
    },
    isBannerOpen() {
      return this.stepping?.banner
    },
  },

}
</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.teq-container {
  margin: 0 auto !important;

  @include teq-breakpoint($large) {
    margin: 0.2rem auto !important;
  }
}

.nav-hero {
  align-content: center;
  align-items: center;
  background-color: $gray;
  display: flex;

  @include teq-breakpoint($large) {
    background-color: $gray;
    border-bottom: none;
    height: 4.8rem;
    justify-content: space-between;
  }

  &__logo {
    margin-left: auto;
    margin-right: 0;

    &--small {
      height: 3.7rem;
      width: 5.5rem;

      @include teq-breakpoint($medium) {
        display: none;
      }
    }

    &--large {
      display: none;

      @include teq-breakpoint($medium) {
        display: block;
        height: 100%;
        width: 13.4rem;
      }
    }
  }
}

.teq-container {
  margin: 0.2rem auto;
  max-width: 100%;
  width: 100%;

  @include teq-breakpoint($large) {
    //width: calc(100% - 186px);
    padding: 0 93px;
  }

  &.banner-active {
    margin-top: -1rem !important;
    padding: 1rem;

    @include teq-breakpoint($large) {
      margin-top: auto !important;
      padding: 0 93px;
    }
  }

  &.stepping-active {
    margin-bottom: 0;
    margin-top: -1rem;

    @include teq-breakpoint($large) {
      margin-bottom: auto;
      margin-top: auto;
    }
  }
}

.logo-link {
  color: #000;
  font-family: $f-graphie-book;
  font-size: 1.4rem;
  line-height: 1.4rem;
  position: relative;
  text-align: center;
  width: 100%;

  @include teq-breakpoint($medium) {
    margin-right: 1.3rem;
  }

  &.-svg {
    svg,
    img {
      height: 35px;
      width: 195px;
    }
  }

  strong {
    font-family: $f-graphie-bold;
  }

  //   &::before {
  //     @include teq-breakpoint($medium) {
  //       background: #ddd;
  //       content: '';
  //       height: 1.4rem;
  //       position: absolute;
  //       right: -0.8rem;
  //       top: 0;
  //       width: 1px;
  //     }
  //   }
}

.gray-link {
  color: #777;
  display: none;
  font-family: $f-graphie-book;
  font-size: 1.3rem;
  line-height: 1.4rem;
  position: relative;

  @include teq-breakpoint($medium) {
    display: initial;
    margin-right: 1.3rem;
  }

  &.-line {
    @include teq-breakpoint($medium) {
      &::before {
        background: #ddd;
        content: '';
        height: 1.4rem;
        position: absolute;
        right: -0.6rem;
        top: 0;
        width: 1px;
      }
    }
  }
}

.tagline {
  color: #000;
  font-family: $f-graphie-lt;
  font-size: 1.2rem;
  line-height: 2rem;
}

.mobility-logo-container {
  width: 76%;

  @include teq-breakpoint($medium) {
    width: 40%;
  }

  @include teq-breakpoint($wide) {
    text-align: end;
    width: 60.5%;
  }

  &.-hidden-mobile-scroll {
    display: none;

    @include teq-breakpoint($medium) {
      display: block;
      text-align: left;
      width: 33%;
    }
  }
}

.nav-hero--steps {
  display: flex;

  @include teq-breakpoint($medium) {
    display: none;
  }
}

.menu-desktop {
  display: none;

  @include teq-breakpoint($medium) {
    display: block;
  }
}

.menu-mobile {
  display: flex;
  width: 100%;

  @include teq-breakpoint($medium) {
    display: none;
  }
}

.header-booking-button {
  align-items: center;
  display: flex;
  flex-direction: row;
  width: calc(100% - 6rem);

  @include teq-breakpoint($medium) {
    width: 30%;
  }

  @include teq-breakpoint($wide) {
    width: 33%;
  }
}

.icon-glass {
  height: 1.5rem;
  width: 1.5rem;
}

.burger-menu {
  padding-left: 15px;
  width: 3.7rem;

  @include teq-breakpoint($medium) {
    display: none;
  }
}

.button-header {
  @include font-size(12px);

  background-color: $c-alto !important;
  border: none !important;
  box-sizing: border-box;
  font-family: $f-graphie-book;
  height: 3.6rem;
  line-height: 3.6rem;
  margin-bottom: 0;
  margin-left: 15px;
  min-height: 3.6rem;
  padding: 0 1.2rem;
  text-transform: initial;
  width: 80%;

  &:hover {
    background-color: $c-alto !important;
  }

  &:focus {
    color: black !important;
  }

  @include teq-breakpoint($large) {
    box-sizing: border-box;
    height: 4.6rem;
    margin: 0 auto;
    margin-left: auto;
    max-width: 28rem;
    padding: 0 3rem;
    width: auto;
  }
}

.logo-container {
  display: flex;
  height: 3.7rem;
  justify-content: flex-end;
  min-width: 5.5rem;
  width: 5.5rem;

  @include teq-breakpoint($medium) {
    width: 30%;
  }

  @include teq-breakpoint($wide) {
    height: 4rem;
    min-width: 33%;
    width: 33%;
  }
}

svg {
  height: 18px;
  margin-right: 10px;
  width: 18px;
}

a:hover {
  cursor: pointer;
}

.logo-mobile {
  height: 33px;
  width: 100%;

  @include teq-breakpoint($medium) {
    margin-bottom: auto;
  }
}

.illust {
  height: 3rem;
  margin-left: 15px;
  width: 3rem;
}

</style>
